'use strict';
/**
 * Messages traveling between two direct neighbors. It requests from the
 * receiving peer that it initiates a connection with the emitter.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var MDirect = function MDirect() {
  _classCallCheck(this, MDirect);

  this.type = 'MDirect';
};

;
module.exports = MDirect;